import styled from 'styled-components';

export const StructureWrapper = styled.div`
  margin-bottom: 12px;
`;
